"use client";

import { useEffect } from "react";
import { useSelector } from "react-redux";

/**
 *
 * @returns and sets the value for a cursor url in from web feature control
 */
export default function CursorManager() {
  const cursor = useSelector((state) => state?.webFeatureControls?.data?.cursorUrl);

  useEffect(() => {
    if (!cursor) return;

    const value = `url("${cursor}") 0 0, auto`;

    document.documentElement.style.setProperty("--app-cursor", value);

    return () => {
      document.documentElement.style.setProperty("--app-cursor", "auto");
    };
  }, [cursor]);

  return null;
}
